import { render } from "./DashboardPantallas.vue?vue&type=template&id=679bea21"
import script from "./DashboardPantallas.vue?vue&type=script&lang=js"
export * from "./DashboardPantallas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__